import React from 'react';
import { makeStyles, Switch, Tooltip } from '@material-ui/core';

import buttonStyles from './styles';

const useStyles = makeStyles(() => ({
  toggleSwitchContainer: {
    marginLeft: 4,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

type Props = {
  checked: boolean;
  className?: string;
  name: string;
  taskType: 'ball actions' | 'player positions';
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const LegacyLabelAssistantToggleButton = (props: Props) => {
  const buttonClasses = buttonStyles();
  const classes = useStyles();
  const { checked, className, name, taskType, onChange } = props;

  return (
    <Tooltip
      title={`Switch to older ${taskType} endpoint (use only if experiencing issues with the new ${taskType} API).`}
      arrow
    >
      <div className={`${checked ? buttonClasses.toggleIconActive : buttonClasses.toggleIcon} ${classes.toggleSwitchContainer} ${className || ''}`}>
        <Switch color="primary" size="small" checked={checked} onChange={onChange} name={name} />
      </div>
    </Tooltip>
  );
};

export default LegacyLabelAssistantToggleButton;
